import {
  ADMIN_OPERATIONS,
  adminOperationPath,
  type AdminOperationId,
} from "@price-rescue/api-contracts/openapi/admin-operations";

export const ADMIN_API_ROUTES = Object.fromEntries(
  Object.entries(ADMIN_OPERATIONS).map(([key, descriptor]) => [key, descriptor.path]),
) as { readonly [Key in AdminOperationId]: (typeof ADMIN_OPERATIONS)[Key]["path"] };

export type AdminApiRouteName = AdminOperationId;

export function adminApiPath(name: AdminApiRouteName, params: Record<string, string> = {}): string {
  return adminOperationPath(ADMIN_OPERATIONS[name], params);
}
